<template>
  <div class="mb-4">
    <template v-if="question != null">
      <v-card outlined :class="[hasError ? 'has-error' : '']">
        <div class="pa-3">
          <question-renderer :question="question"></question-renderer>
        </div>
        <!-- <v-divider class="my-3"></v-divider> -->
        <div class="wysiwyg-content px-3" id="choices-block" ref="choicesBlock">
          <v-radio-group
            v-model="answer"
            class="mt-0 pt-0"
            @change="onAnswerChange"
            dense
          >
            <template v-for="(item, idx) in question.choices">
              <div class="d-flex align-center" :key="`choice_${idx}`">
                <div class="grow" style="max-width: 100%">
                  <v-radio :value="item._id">
                    <template v-slot:label>
                      <div class="my-2" v-html="item.text"></div>
                    </template>
                  </v-radio>
                </div>
              </div>
            </template>
          </v-radio-group>
        </div>

        <v-overlay :value="overlay">
          <pinch-zoom v-bind:properties="myProperties">
            <img :src="imgPinch" />
          </pinch-zoom>
          <v-btn class="ma-2 btn-close" fab dark small @click="overlay = false">
            <v-icon>far fa-times</v-icon>
          </v-btn>
        </v-overlay>
      </v-card>
    </template>
    <template v-else>
      <v-alert text type="warning" dense> Can not render question </v-alert>
    </template>
  </div>
</template>

<script>
import PinchZoom from "vue-pinch-zoom";
import QuestionRenderer from "./QuestionRenderer";
import sessionHelper from "../services/evaluateSession";
import EventBus from "../plugins/event-bus";

export default {
  name: "QuestionComponent",
  props: {
    question: {
      type: Object,
    },
    sessionId: {
      type: String,
    },
    sectionId: {
      type: String,
    },
  },
  components: {
    QuestionRenderer,
    PinchZoom,
  },
  data: () => ({
    answer: null,
    overlay: false,
    myProperties: {
      overflow: "visible",
    },
    imgPinch: null,
    sub: null,
    hasError: false,
  }),
  computed: {
    showCorrectAnswer() {
      return false;
    },
    readOnly() {
      return this.$store.state.readOnly;
    },
  },
  watch: {},
  mounted() {
    this.answer = null;
    this.init();
    //#region image binding to pinch zoom
    this.$nextTick().then(() => {
      // find img
      let imgs = this.$refs.choicesBlock.querySelectorAll("img");
      for (let img of imgs) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        img.addEventListener("click", (e) => {
          this.showOverlay(e);
        });
      }

      let links = this.$refs.choicesBlock.querySelectorAll("a");
      for (let link of links) {
        // img.style.maxWidth = "100%";
        // img.style.height = "auto";
        link.addEventListener("click", (e) => {
          e.preventDefault();
          EventBus.$emit("internalBrowser", e.target.href);
        });
      }
    });
    //#endregion
  },
  methods: {
    showOverlay(e) {
      this.imgPinch = e.target.src;
      this.overlay = true;
    },
    setColor(value) {
      return "primary";
    },
    setColorText(value) {
      return [""];
    },
    init() {
      if (this.question.state != null) {
        this.answer = this.question.state;
      }
    },
    getAnswer() {
      return this.answer;
    },
    onAnswerChange(val) {
      // console.log(val);
      if (val != null) {
        this.hasError = false;
        this.saveAnswer(val);
      }
    },
    saveAnswer(val) {
      EventBus.$emit("overlay", true);
      sessionHelper
        .saveAnswer(this.sessionId, {
          sectionId: this.sectionId,
          questionId: this.question._id,
          priority: this.question.priority,
          value: val,
        })
        .then((resp) => {
          // do nothing
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          EventBus.$emit("overlay", false);
        });
    },
    validate() {
      if (this.answer == null) {
        this.hasError = true;
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 100%;
}
.v-toolbar ::v-deep .v-toolbar__content,
.v-toolbar ::v-deep .v-toolbar__extension {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
#choices-block ::v-deep * img {
  max-width: 100%;
}

::v-deep .btn-close {
  position: fixed;
  top: 0px;
  right: 0px;
}
.has-error {
  border-color: #ef9a9a !important;
  background-color: #ffebee !important;
}
</style>